/*
 * First visit only: shows the shop in the language and currency of the
 * shopper's country, detected from the IP by Shopify
 * (/browsing_context_suggestions.json). The country picks the currency
 * through its market; the language follows LANGUAGES below. A shopper who
 * arrives on a language URL (/it/…, /en/…) keeps that language. The choice is
 * made once per browser, so the header selector always wins afterwards.
 * Settings and the localization form come from snippets/nz-geo.liquid.
 */
(() => {
  const KEY = 'nz-geo';
  const LANGUAGES = { FR: 'fr', BE: 'fr', LU: 'fr', MC: 'fr', CH: 'fr', IT: 'it', SM: 'it', VA: 'it' };
  const ROBOTS = /bot|crawl|spider|slurp|preview|lighthouse|facebookexternalhit|headless/i;

  const form = document.getElementById('NzGeoForm');
  let config;
  try {
    config = JSON.parse(document.getElementById('nz-geo-config')?.textContent || '{}');
    if (!form || localStorage.getItem(KEY) || window.Shopify?.designMode) return;
  } catch {
    return; // no storage: never redirect, it could loop
  }
  if (navigator.webdriver || ROBOTS.test(navigator.userAgent)) return;

  fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true')
    .then((response) => response.json())
    .then((data) => {
      const detected = (data?.detected_values?.country?.handle || '').toUpperCase();
      localStorage.setItem(KEY, detected || '-');
      if (!detected || !config.countries?.includes(detected)) return;

      const root = window.Shopify?.routes?.root || '/';
      const onLanguageUrl = root !== '/';
      const wanted = LANGUAGES[detected] || 'en';
      const language = onLanguageUrl || !config.languages?.includes(wanted) ? config.language : wanted;
      if (detected === config.country && language === config.language) return;

      form.elements.country_code.value = detected;
      form.elements.language_code.value = language;
      // Back to the same page and query string (ad parameters included), in
      // the new language: Shopify adds the locale prefix to this path.
      const path = location.pathname.slice(root.length - 1) || '/';
      if (form.elements.return_to) form.elements.return_to.value = path + location.search;
      form.submit();
    })
    .catch(() => {
      // Detection failed: the shop stays as it is and asks again next visit.
      localStorage.removeItem(KEY);
    });
})();
